import * as React from 'react';
import { IconProductTrust16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './NewBuildingCard.css';
import { Responsive } from '@cian/ui-kit';
import { Ratings } from '../NewbuildingCardRatings';
import { IReviewStat } from '../../types/developerV2/review';
import { clsx } from 'clsx';

interface INewBuildingCardProps {
  isReliable: boolean;
  url: string;
  image: React.ReactNode;
  title: React.ReactNode;
  finishLabel: React.ReactNode;
  subwayInfo: React.ReactNode;
  address: React.ReactNode;
  apartments?: React.ReactNode;
  onTitleClick?(): void;
  onApartmentsClick?(): void;
  onImageClick?(): void;
  reviewsStats?: IReviewStat;
  singleCard?: boolean;
}

export function NewBuildingCard({
  image,
  isReliable,
  url,
  title,
  finishLabel,
  subwayInfo,
  address,
  apartments,
  onTitleClick,
  onApartmentsClick,
  onImageClick,
  reviewsStats,
  singleCard,
}: INewBuildingCardProps) {
  return (
    <article className={clsx(styles['card'], singleCard && styles['card--single'])}>
      <a href={url} target="_blank" rel="noopener noreferrer" className={styles['image']} onClick={onImageClick}>
        {image}
      </a>

      <div className={styles['body']}>
        <a href={url} target="_blank" rel="noopener noreferrer" className={styles['title']} onClick={onTitleClick}>
          {title}

          {isReliable && (
            <span className={styles['reliable']}>
              <IconProductTrust16 color="icon-main-default" />
            </span>
          )}
        </a>

        <div className={styles['item']}>{finishLabel}</div>

        {reviewsStats && (
          <Ratings
            reviewCountText={reviewsStats.reviewCountText}
            totalRate={reviewsStats.totalRate}
            reviewCount={reviewsStats.reviewCount}
          />
        )}

        <div className={styles['item']}>{subwayInfo}</div>
        <div className={styles['item']}>{address}</div>

        <Responsive desktop>
          {apartments && (
            <div className={styles['apartments']} onClick={onApartmentsClick}>
              {apartments}
            </div>
          )}
        </Responsive>
      </div>
    </article>
  );
}
